import { useEffect } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { useClientOptions, useUser } from '@paintscout/ui-business'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useSubscriptionSummaryQuery } from '@paintscout/api'
import { getCRMAddonProductId } from '@paintscout/util'

export const EXPIRE_OPERATIONS_TRIAL = gql`
  mutation expireOperationsTrial {
    expireOperationsTrial
  }
`

// Turns Operations off once a trial ends without the add-on being bought. A cancelled trial has
// already lost its add-on in Chargebee but keeps access until trialExpiration (ENG-2163). The server
// re-checks every condition, and also deactivates painters, which a bare flag flip would miss.
export default function CRMTrialSync() {
  const { options } = useClientOptions()
  const { user } = useUser()
  const { crm } = useFlags()
  const trialExpiration = options.options?.crm?.trialExpiration
  const [expireOperationsTrial] = useMutation(EXPIRE_OPERATIONS_TRIAL)

  const { data: subscriptionData, loading } = useSubscriptionSummaryQuery({
    fetchPolicy: 'network-only',
    skip: !user?.app_metadata?.company?.billingId,
    variables: {
      clientBillingId: user?.app_metadata?.company?.billingId
    }
  })

  useEffect(() => {
    if (!trialExpiration) return

    const syncCRMTrial = async () => {
      const now = Date.now()
      const subscription = subscriptionData?.subscriptionSummary
      const addons = subscription?.addons
      const isOnExpiredTrial =
        trialExpiration < now &&
        crm &&
        Array.isArray(addons) &&
        !addons.some((addon) => addon.id === getCRMAddonProductId(subscription)) &&
        !loading

      if (isOnExpiredTrial) {
        await expireOperationsTrial()
      }
    }

    syncCRMTrial().catch(console.error)
  }, [trialExpiration, crm, subscriptionData])

  return null
}
